import React from 'react';
import { Group, Button, Select } from '@mantine/core';
import styles from './PaymentSplitButton.module.css';

export function PaymentSplitButton({ 
  options, 
  value, 
  onChange, 
  onSelect,
  color = 'green' 
}) {
  return (
    <Group className={styles.splitButtonContainer} gap={0}>
      <Button
        variant="outline"
        color={color}
        onClick={() => onSelect(value)}
        className={styles.mainButton}
        size="lg"
      >
        {value}
      </Button>
      <Select
        data={options.filter(opt => opt.value !== value)}
        value={null}
        onChange={onChange}
        className={styles.dropdown}
        p={0}
        classNames={{
          input: styles.dropdownInput,
          dropdown: styles.dropdownMenu
        }}
        variant="outline"
        size="lg"
        withinPortal
      />
    </Group>
  );
} 